import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { CancelSubmitButtons, TransitionEffect } from "~/common/components";

interface ConsultationQuestionsLayoutProps extends PropsWithChildren {
  title?: string;
  handleNext: () => void;
  handleBack: () => void;
  disableNext?: boolean;
  disableBack: boolean;
  isSubmitting: boolean;
  supertitle?: string;
  subtitle?: string;
  errors?: string;
  submitButtonLabel?: string;
  cancelSubmitButtonsClassName?: string;
}

export const ConsultationQuestionsLayout = ({
  children,
  title,
  handleNext,
  handleBack,
  disableNext = false,
  disableBack,
  isSubmitting,
  subtitle,
  supertitle,
  errors,
  submitButtonLabel,
  cancelSubmitButtonsClassName,
}: ConsultationQuestionsLayoutProps) => (
  <div className="items-left flex w-full flex-grow flex-col overflow-y-auto px-6 md:px-0">
    <TransitionEffect
      duration={300}
      className="mx-auto flex w-full flex-1 flex-col md:w-1/2 xl:w-1/4"
    >
      {supertitle && <p className="mb-4">{supertitle}</p>}
      {(title ?? subtitle) && (
        <div className="mb-11 flex flex-col gap-2">
          <p className="text-lg font-medium leading-5 first-letter:capitalize">
            {title}
          </p>
          <p className="text-gray-10">{subtitle}</p>
        </div>
      )}
      <form
        className="flex flex-grow flex-col justify-between gap-3 text-gray-70"
        onSubmit={handleNext}
        autoComplete="off"
      >
        <fieldset
          disabled={isSubmitting}
          className="flex h-full flex-col justify-between gap-14"
        >
          <div className="flex h-full flex-col gap-2">
            <div className="flex h-full w-full flex-col gap-3">{children}</div>
            {errors && <p className="text-sm text-red-600">{errors}</p>}
          </div>
          <CancelSubmitButtons
            submitButtonId="nextButton"
            cancelButtonId="backButton"
            variant="separated-outline-none"
            cancelButtonLabel="Back"
            isSubmitting={isSubmitting}
            handleCancel={handleBack}
            disableCancel={isSubmitting}
            disableSubmit={disableNext}
            submitButtonLabel={submitButtonLabel ?? "Next"}
            containerClassName={twMerge(
              disableBack && "justify-end",
              cancelSubmitButtonsClassName,
            )}
            cancelClassName={twMerge(
              "disabled:bg-transparent disabled:cursor-not-allowed",
              disableBack && "hidden",
            )}
          />
        </fieldset>
      </form>
    </TransitionEffect>
  </div>
);
